import { useClient, useClients } from '@entities/clients';
import { type FC } from 'react';
import { ClientAvatar, ClientMenu, Info, Name } from '@features/clients';
import { Color } from '@features/clients/client-color';
import type { ColorTag } from '@shared/types/common';
import type { Client } from '@shared/types/users';
import * as st from './styles.module.scss';

type Props = {
  selectedColorTag: ColorTag | null;
  client: Client;
};

export const ClientCardOld: FC<Props> = ({ selectedColorTag }) => {
  const { selectedClient: selected } = useClients();
  const { client } = useClient(selected!);

  return (
    <div className={st.client}>
      {client && <Color client={client} selectedColorTag={selectedColorTag} />}
      <section className={st.client__photo}>
        {client && <ClientAvatar size="md" client={client} />}
      </section>
      <section className={st.client__data}>
        {client && (
          <>
            <Name client={client} />
            <Info client={client} />
          </>
        )}
      </section>
      <section className={st.client__menu}>{client && <ClientMenu client={client} />}</section>
    </div>
  );
};
export const ClientCard: FC<Props> = ({ client, selectedColorTag }) => {
  return (
    <div className={st.client}>
      <>
        <Color client={client} selectedColorTag={selectedColorTag} />
        <section className={st.client__photo}>
          <ClientAvatar size="md" client={client} />
        </section>
        <section className={st.client__data}>
          <>
            <Name client={client} />
            <Info client={client} />
          </>
        </section>
        <section className={st.client__menu}>{client && <ClientMenu client={client} />}</section>
      </>
    </div>
  );
};
